@if (hoursFromDday != 0) {
  <span>{{ hoursFromDday }}h </span>
}
<span>{{ minutesFromDday }}m </span>
@if (presentStopwatchSeconds) {
  <span>{{ secondsFromDday }}s</span>
}
